import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import {ToastrService} from "ngx-toastr";
import {take} from "rxjs/internal/operators";
import {Router} from "@angular/router";
import {AccountService} from "./singelton/account.service";
import {IMessage} from "./shared/model/chat.message.model";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  constructor(private spinner: NgxSpinnerService,
              private translate: TranslateService,
              private toastr: ToastrService,
              private router: Router,
              private accountService: AccountService

) {

    translate.setDefaultLang('fa');
    //
    // // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('fa');
    this.spinner.show();

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      // this.spinner.hide();
    }, 5000);

    this.accountService.chatMessageAdded.subscribe((data) => {

      // reading content of the received message
      let m : IMessage;

      m = JSON.parse(data);

      //check different types of notifications
      if(m.type === "CALL_CENTER_NOTIFICATION")
      {

      } else {
        this.showToaster(data);
      }

    });
  }


  playAudio() {
    // Disabled: ding sound caused download/file-manager popup when asset missing or MIME wrong
    // const script: HTMLAudioElement = <HTMLAudioElement>document.getElementsByTagName('audio')[0];
    // if (script) { script.play(); }
  }

  pauseAudio() {
    // const script: HTMLAudioElement = <HTMLAudioElement>document.getElementsByTagName('audio')[0];
    // if (script) { script.pause(); }
  }

  showToaster(data: any) {

 //   alert(JSON.stringify(data));

    // Disabled ding playback (see playAudio)
    // const script: HTMLAudioElement = <HTMLAudioElement>document.getElementsByTagName('audio')[0];
    // if (script) { script.play(); }

    let t =  JSON.parse(data);

    const dr = ' برای شما یک پیگیری جدید ثبت شده است. ';
    const pm = ''+t.sender + ' یک پیگیری جدید در ارتباط با '+ t.targetEntity + ' برای شما ثبت کرد';
    this.toastr.info(pm, 'پیام جدید!',{
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: true,
      closeButton: true,
      positionClass: 'toast-bottom-left'
      // tapToDismiss: true
      // toastComponent: CustomComponent
    })
      .onTap
      .pipe(take(1))
      .subscribe(() => this.toasterClickedHandler(t));
  }

  toasterClickedHandler(t: any) {
    console.log('Toastr clicked');

    this.router.navigate(['/page/profile-customer/' + t.content + '/project' ]);
    // this.clear();

  }
}
